module.exports = __webpack_public_path__ + "static/media/bannerdiners.0caed855.jpg";